import axios from "axios";
import { APIDomain, APIEndPOints } from "./api-config";
import { AuthAPI } from "./auth-api";

export class VantagePortalAPI {
  static getUserAccessList = async () => {
    try {
      let _curUser = await AuthAPI.validateCurrentUser();
      let [email, token] = [_curUser.email, _curUser.accessToken];
      let API = APIDomain + APIEndPOints.getUserAccessList + email;

      const response = await axios.get(API, {
        headers: {
          Authorization: "Bearer " + token,
          "x-user-agent": "Rentokil"
        },
      });
      return response.data.iCabsInstances;
    } catch (err) {
      alert(err);
    }
  };

  static getUserRole = async (countryCode, businessCode) => {
    try {
      let _curUser = await AuthAPI.validateCurrentUser();
      let [email, token] = [_curUser.email, _curUser.accessToken];
      let API = APIDomain + APIEndPOints.getUserRole;

      API = API.replace("<email>", email);
      API = API.replace("<countryCode>", countryCode);
      API = API.replace("<businessCode>", businessCode);
      const response = await axios.get(API, {
        headers: {
          Authorization: "Bearer " + token,
          "x-user-agent": "Rentokil"
        },
      });

      return response.data;
    } catch (err) {
      alert(err);
    }
  };
}
